import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const Section = ({ title, children, testId }) => (
  <section data-testid={testId} className="mt-10">
    <h2 className="font-display text-lg font-bold text-[#1A1918]">{title}</h2>
    <div className="mt-3 space-y-3 text-sm leading-relaxed text-[#5C5A56] md:text-base">{children}</div>
  </section>
);

export default function PrivacyPolicy() {
  return (
    <main data-testid="privacy-page" className="min-h-screen bg-[#FDFBF7] text-[#1A1918]">
      <div className="mx-auto w-full max-w-3xl px-6 py-10 md:py-16">
        <Link
          to="/"
          data-testid="back-home-link"
          className="inline-flex items-center gap-2 text-sm font-medium text-[#5C5A56] transition-colors duration-200 hover:text-[#C65C47]"
        >
          <ArrowLeft className="h-4 w-4" />
          Back to home
        </Link>

        <h1 data-testid="privacy-title" className="font-display mt-8 text-4xl font-bold tracking-tight sm:text-5xl">
          Privacy Policy
        </h1>
        <p data-testid="privacy-updated" className="mt-4 text-sm text-[#5C5A56]">
          Last updated: July 2026
        </p>

        <Section title="What Class Bridge does" testId="privacy-section-about">
          <p>
            Class Bridge is an AI teaching companion that helps teachers turn classroom recordings
            into transcripts and ready-to-share updates for parents and students.
          </p>
        </Section>

        <Section title="Information we process" testId="privacy-section-data">
          <p>Depending on how the app is used, this may include:</p>
          <ul className="list-disc space-y-2 pl-5">
            <li>Teacher account and contact details.</li>
            <li>Class audio recordings uploaded by the teacher.</li>
            <li>Transcripts and generated class summaries.</li>
            <li>Parent or student contact details added for sharing updates.</li>
          </ul>
        </Section>

        <Section title="How information is used" testId="privacy-section-use">
          <p>
            We use this information to provide transcription, generate class updates, deliver those
            updates to intended recipients, and improve accuracy and reliability of the service.
          </p>
        </Section>

        <Section title="Sharing" testId="privacy-section-sharing">
          <p>
            Class updates are shared only with the recipients chosen by the teacher or school. We do
            not sell personal information.
          </p>
        </Section>

        <Section title="Data retention and security" testId="privacy-section-retention">
          <p>
            Recordings and transcripts are kept only as long as needed to provide the service, and we
            use reasonable safeguards to protect them.
          </p>
        </Section>

        <Section title="Contact" testId="privacy-section-contact">
          <p>
            For privacy questions, contact us at{" "}
            <a
              href="mailto:hello@class-bridge.com"
              data-testid="privacy-contact-link"
              className="font-medium text-[#A64B38] underline-offset-4 transition-colors duration-200 hover:underline"
            >
              hello@class-bridge.com
            </a>
            .
          </p>
        </Section>
      </div>
    </main>
  );
}
